import { GuidedTourStep } from '../../../../model/guided-tour-step';
import { HighlightDialogConfig } from '../../../../model/highlight-dialog';

export const MY_SERVICES_GUIDED_TOUR_STEPS: GuidedTourStep[] = [
  // 1
  {
    highlightTargetId: 'services-tile-content',
    clickTargetId: 'services',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section4.description.step1',
    },
    border: 20,
    nextOnOverlayClick: true,
    hideArrow: true,
  },
  // 2
  {
    highlightTargetId: 'mdc-tab-2',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section4.description.step2',
    },
    hideArrow: true,
  },
  // 3
  {
    highlightTargetId: 'markant-body',
    shape: 'rectangle',
    ignoreHighlightClick: true,
    hideBackButton: true,
    nextOnOverlayClick: true,
  },
  // 4
  {
    highlightTargetId: '',
    border: -30,
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section4.description.step4',
    },
    hideArrow: true,
  },
  // 5
  {
    highlightTargetId: '',
    border: 50,
    arrowAttachment: 'auto',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section4.description.step5',
    },
    nextOnOverlayClick: true,
  },
  // 6
  {
    highlightTargetId: 'mdc-tab-5',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section4.description.step6',
    },
    hideArrow: true,
  },
  // 7
  {
    highlightTargetId: 'services-tile-content',
    clickTargetId: 'services',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section4.description.step7',
    },
    hideArrow: true,
  },
  // 8
  {
    highlightTargetId: 'markant-body',
    shape: 'rectangle',
    ignoreHighlightClick: true,
    hideBackButton: true,
    nextOnOverlayClick: true,
  },
  // 9
  {
    highlightTargetId: 'my-services-tour-highlight-dialog',
    description: { text: 'guidedTour.tours.guided-tour-oa-admin-area.section4.description.step9' },
    shape: 'rectangle',
    ignoreHighlightClick: true,
    arrowAttachment: 'auto',
  },
  // 10
  {
    highlightTargetId: 'my-services-tour-highlight-dialog',
    description: { text: 'guidedTour.tours.guided-tour-oa-admin-area.section4.description.step9' },
    shape: 'rectangle',
    border: -0.1,
    ignoreHighlightClick: true,
    arrowAttachment: 'auto',
  },
  // 11
  {
    highlightTargetId: 'my-services-tour-highlight-dialog',
    description: { text: 'guidedTour.tours.guided-tour-oa-admin-area.section4.description.step9' },
    shape: 'rectangle',
    border: -0.2,
    ignoreHighlightClick: true,
    arrowAttachment: 'auto',
  },
  // 12
  {
    highlightTargetId: 'my-services-tour-highlight-dialog',
    description: { text: 'guidedTour.tours.guided-tour-oa-admin-area.section4.description.step12' },
    shape: 'rectangle',
    ignoreHighlightClick: true,
    arrowAttachment: 'auto',
  },
  // 13
  {
    highlightTargetId: 'my-services-tour-highlight-dialog',
    description: { text: 'guidedTour.tours.guided-tour-oa-admin-area.section4.description.step12' },
    shape: 'rectangle',
    border: -0.1,
    ignoreHighlightClick: true,
    arrowAttachment: 'auto',
  },
];

export const SERVICES_HIGHLIGHT_DIALOG_CONFIG: HighlightDialogConfig = {
  position: {
    position: 'absolute',
    vertical: {
      from: 'top',
      amount: '16px',
    },
  },
};
